import { FluctuationBaseColumn } from './fluctuation-base-column';

/**
 * Column Clicks with Fluctuation.
 * @extends FluctuationBaseColumn
 */
export class ColumnClicksWithFluctuation extends FluctuationBaseColumn {
  constructor({ i18n, helpId }) {
    super({
      name: 'Clicks',
      format: 'integer',
      i18n,
      helpId,
    });
  }
}

/**
 * Column Impressions with Fluctuation.
 * @extends FluctuationBaseColumn
 */
export class ColumnImpressionsWithFluctuation extends FluctuationBaseColumn {
  constructor({ i18n, helpId = 'Page_CampaignGrids_Impr' }) {
    super({
      name: 'Impressions',
      format: 'integer',
      i18n,
      helpId,
    });
  }
}

/**
 * Column Spend with Fluctuation.
 * @extends FluctuationBaseColumn
 */
export class ColumnSpendWithFluctuation extends FluctuationBaseColumn {
  constructor({ i18n, helpId }) {
    super({
      name: 'Spend',
      format: 'decimal',
      i18n,
      helpId,
    });
  }
}


/**
 * All performance metrics columns with fluctuation
 * @type Class[]
 */
export const fluctuationColumns = [
  ColumnClicksWithFluctuation,
  ColumnImpressionsWithFluctuation,
  ColumnSpendWithFluctuation,
];

